import { rangeTypes } from '../../pages/RangePage/rangeNameConverter';
import { GET_CONTENT, GET_NEWS_AND_EVENT, GET_NEWS_AND_EVENTS } from '../constants';

const getUrl = (locale, contentType, slug) =>
  ({
    aboutPage: `/${locale}/about`,
    campaignPage: `/${locale}/news-and-events/${slug}`,
    contactUsPage: `/${locale}/contact-us`,
    editorial: `/${locale}/inspiration/${slug}`,
    educationPage: `/${locale}/education`,
    heritagePage: `/${locale}/heritage`,
    homePage: `/${locale}`,
    inspirationPage: `/${locale}/inspiration`,
    newsAndEventsPage: `/${locale}/news-and-events`,
    ourAssetsPage: `/${locale}/assets`,
    product: `/${locale}/product/${slug}`,
    salonInfoUpdatePage: `/${locale}/salon-info-update`,
    seminar: `/${locale}/education/${slug}`,
    seminarSchedulePage: `/${locale}/seminar-schedule`,
    style: `/${locale}/style/${slug}`,
    termsOfUse: `/${locale}/terms-of-use`,
    termsOfUseColorMirror: `/${locale}/terms-of-use-colormirror`,
    treatment: `/${locale}/treatment/${slug}`,
    creatorsPage: `/${locale}/creators`,
    recruitPage: `/${locale}/recruit`,
    articlePage: `/${locale}/beautyforyou/${slug}`,
    salonList: `/${locale}/salon-list/${slug}`,
    ...rangeTypes.reduce(
      (acc, range) => ({ ...acc, [range.contentType]: `/${locale}/range/${range.slug}/${slug}` }),
      {}
    ),
    // パスマッチさせた時に data を引き渡すため、アクセスしたパスを引き渡す
    // 例) /ja_jp/inspiration/beautystream-20ss/youngactivistsrising
    inspirationArticle: window.location.pathname,
  }[contentType]);

const processPage = (state, entry, locale) => {
  const map = {};

  const addPage = (state, entry, locale) => {
    if (map[entry.entryId] || entry.isLink) return state;
    const url = getUrl(locale, entry.contentType, entry.slug);
    if (state[url]) return state;

    map[entry.entryId] = true;
    let newState = url ? { ...state, [url]: entry.entryId } : { ...state };
    Object.keys(entry).forEach(key => {
      const field = entry[key];
      if (Array.isArray(field) && field.length && field[0].entryId) {
        newState = field.reduce((state, entry) => addPage(state, entry, locale), newState);
      } else if (typeof field === 'object' && field.entryId) {
        newState = addPage(newState, field, locale);
      }
    });

    return newState;
  };

  return addPage(state, entry, locale);
};

export default (state = {}, action) => {
  switch (action.type) {
    case `${GET_NEWS_AND_EVENT}_FULFILLED`:
    case `${GET_NEWS_AND_EVENTS}_FULFILLED`:
    case `${GET_CONTENT}_FULFILLED`: {
      const { data, locale } = action.payload;

      if (Array.isArray(data)) {
        return data.reduce((state, entry) => processPage(state, entry, locale), state);
      }
      return processPage(state, data, locale);
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/pages.js